// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LegalPage_wrapper__guiuc"};